import { render, staticRenderFns } from "./AppTableHeaderItem.vue?vue&type=template&id=328908f2"
import script from "./AppTableHeaderItem.vue?vue&type=script&lang=js"
export * from "./AppTableHeaderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports